module.exports = __webpack_public_path__ + "img/Box_big.f966c854.png";